import { useSelector, useDispatch } from "react-redux";
import styles from "./ShuffleHeader.module.scss";
import ShuffleIcon from "../../../../assets/icons/shuffle_icon.svg";
import Shuffle from "../../../../assets/icons/shuffle.svg";
import CloseIcon from "../../../../assets/icons/close.svg";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";

const ShuffleHeader = ({
  selections = [],
  getShuffleSelections = () => {},
  isLoading = false,
  setIsLoading = () => {},
  shuffled = false,
  setShuffled = () => {},
}) => {
  const betslipStore = useSelector((state) => state.betslip);
  const dispatch = useDispatch();
  const allSelectionsActive =
    !isLoading &&
    selections.every((selection) =>
      betslipStore.selections.some(
        (betslipSelection) =>
          betslipSelection.id === selection.selection.id &&
          betslipSelection.marketId === selection.selection.marketId
      )
    );

  const closeBetShuffle = () => {
    dispatch({
      type: "SET_ACTIVE_VIEW",
      payload: "",
    });
    setShuffled(false);

    sendAnalyticsEvent({
      event: "Shuffle",
      type: "Shuffle",
      action: "Close",
    });
  };

  const handleAddAllToBetslip = () => {
    // Call BetslipClear and clear betslip reducer to remove all selections if allSelectionsActive is true
    if (allSelectionsActive) {
      dispatch({
        type: "REMOVE_SELECTIONS_FROM_BETSLIP",
        payload: {
          location: "Shuffle",
          selections: selections.map((selection) => {
            return {
              id: selection.selection.id,
              marketId: selection.selection.marketId,
            };
          }),
        },
      });
    } else {
      // If we have no selections in the betslipStore we should add them all to the betslip
      dispatch({
        type: "ADD_ALL_SELECTIONS_TO_BETSLIP",
        payload: {
          location: "Shuffle",
          selections: selections.map((selection) => {
            return {
              id: selection.selection.id,
              marketId: selection.selection.marketId,
              bet: selection,
            };
          }),
        },
      });
    }
  };

  const addAllToBetslipButtonLabel = allSelectionsActive
    ? "Added all to Betslip"
    : "Add all to Betslip";

  const handleShuffle = () => {
    setIsLoading();
    getShuffleSelections();
    setShuffled(true);

    sendAnalyticsEvent({
      event: "Shuffle",
      type: "Shuffle",
      action: "Reshuffle",
    });
  };

  return (
    <div
      className={`${styles.shuffleHeader} ${
        isLoading && !shuffled ? styles["shuffleHeader--loading"] : ""
      }`}
    >
      <div className={styles.shuffleHeaderTop}>
        <div>
          <img src={ShuffleIcon} alt="Shuffle" />
        </div>
        <div>
          <div className={styles.shuffleHeaderColumn}>
            <div>
              <div className={styles.shuffleHeaderTitle}>Bet Shuffle</div>
              <div className={styles.shuffleHeaderText}>
                Take your pick or create your ultimate Bet Builder with a single
                click!
              </div>
            </div>
            <div>
              <button
                type="button"
                aria-label="close-button"
                onClick={closeBetShuffle}
              >
                <img src={CloseIcon} alt="Close" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.shuffleHeaderBottom}>
        <button
          type="button"
          className={`${styles.shuffleHeaderButton} ${
            allSelectionsActive ? styles["shuffleHeaderButton--active"] : ""
          }`}
          onClick={() => handleAddAllToBetslip()}
        >
          {addAllToBetslipButtonLabel}
        </button>
        <button
          type="button"
          aria-label="shuffle-button"
          className={styles.shuffleHeaderButton}
          onClick={() => handleShuffle()}
        >
          Shuffle
          <img src={Shuffle} alt="shuffle" />
        </button>
      </div>
    </div>
  );
};

export default ShuffleHeader;
